import React, { useEffect, useState } from 'react'
import KonfhubContainer from '../../../revampComponents/Atom/Container'
import { ASSET_LABELS, ASSET_TYPE_MAPPING, ASSET_TYPE_REVERSE_MAPPING, ASSET_TYPES, assetValidationSchema } from './AssetLibraryConstant';
import { useParams, useHistory, useLocation } from "react-router-dom";
import { dashboardColors, theme } from '../../../themes/Theme';
import backbtn from '../../../assets/images/back-btn.svg';
import AddNEditAsset from './AddNEditAsset';
import { useFormik } from 'formik'
import * as Yup from 'yup'
import _ from 'lodash'
import customToast from '../../../components/common/basic/Toast';
import { getUTCDateNTime } from '../../../Utils/helpers';
import { cleanPayload } from '../TaskManagement/TaskManagementConstant';
import { diffAndCommon } from '../../../services/util';
import { CrudMessages, ErrMessages } from '../../EventInfo/config/error-constants';
import { errorToaster } from '../../../reusable/common';
import { createAsset, getAssetById, updateAsset } from '../../../revampCRUD/asset.library.crud';
import LoadingSpinner from '../../../revampComponents/Atom/Loading';

const AddNEditAssetInterface = (props) => {
    const { eventId, assetId } = useParams()
    const [isEdit, setIsEdit] = useState(!!assetId)
    const [loading, setLoading] = useState(false)
    const [isExhibitorToggle, setIsExhibitorToggle] = useState(true)
    const history = useHistory()

    const getInitialAssetDetails = () => ({
        task_type: "",
        title: "",
        description: "",
        files: [],
        category_ids: [],
        exhibitor_ids: [],
        task_category_id: '',
    })

    const [assetDetails, setAssetDetails] = useState(getInitialAssetDetails())
    const [editCategorIds, setEditCategoryIds] = useState([]);

    
    const formik = useFormik({
        initialValues: assetDetails,
        validationSchema: assetValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setLoading(true)
            try {
                const updated_details = diffAndCommon("diff", [values, formik?.initialValues], [])
                const cleanedDetails = cleanPayload(updated_details)
                delete cleanedDetails?.category_ids
                delete cleanedDetails?.exhibitor_ids
                const payload = {
                    ...cleanedDetails,
                    task_column_mapping: values?.task_column_mapping || 'custom_task',
                    task_type: (values?.task_type)
                }
                // Handle exhibitor/category assignment logic
                if (isEdit) {
                    // Only include if value changed in edit mode
                    if (!_.isEqual(values?.category_ids, formik?.initialValues?.category_ids)) {
                        payload.category_ids = values?.category_ids
                    }
                    if (!_.isEqual(values?.exhibitor_ids, formik?.initialValues?.exhibitor_ids)) {
                        payload.exhibitor_ids = values?.exhibitor_ids
                    }
                } else {
                    if (isExhibitorToggle) {
                        payload.exhibitor_ids = values?.exhibitor_ids
                    } else {
                        payload.category_ids = values?.category_ids
                    }
                }

                // Handle auto share future
                if (values?.auto_share_future) {
                    payload.auto_assign_type = isExhibitorToggle ? 1 : 2
                }
                if(isEdit) {
                if (values?.task_type) {
                    payload.task_type = ASSET_TYPE_MAPPING[values?.task_type]
                }
            }
                if (isEdit) {
                    if (!_.isEqual(values?.files, formik?.initialValues?.files)) {
                        payload.files = values?.files || []
                    }
                } else {
                    payload.files = values?.files || []
                }

                let response
                if (isEdit) {
                    response = await updateAsset(assetId, payload)
                } else {
                    response = await createAsset(payload)
                }

                if (response?.data) {
                    customToast.success(isEdit ? `Asset ${CrudMessages?.UPDATE_MESSAGE} ` : `Asset ${CrudMessages?.ADDED_MESSAGE}`)
                    formik.resetForm()
                    history.push(`/e/${props?.eventInfo?.event_id}/exhibitor-portal/asset-library`)
                } else {
                    customToast.error(ErrMessages?.DEFAULT_ERROR_MESSAGE)
                }
            } catch (err) {

                const errorMessage = err?.response?.data?.message ||
                    err?.response?.data?.error ||
                    ErrMessages?.DEFAULT_ERROR_MESSAGE

                customToast.error(errorMessage)
            } finally {
                setLoading(false)
            }
        },
    })

    // Fetch existing asset data if editing
    useEffect(() => {
        const fetchAssetData = async () => {
            if (isEdit && assetId) {
                try {
                    setLoading(true)
                    const response = await getAssetById(assetId)
                    const fetchedAssetData = response?.data?.tasks || [];
                    const task = fetchedAssetData?.find((t) => t?.task_id === assetId);
                    if (task) {
                        const { exhibitor_ids, exhibitors , task_type, ...taskDetails } = task;
                        const exhId = exhibitors?.map((exh) => exh?.id?.toString()) || [];
                        const mappedTaskType = ASSET_TYPE_REVERSE_MAPPING[task_type] || task_type;

                        setAssetDetails({
                            task_type: mappedTaskType,
                            exhibitor_ids: task?.category_ids?.length > 0 ? [] : exhId, exhibitors: task?.exhibitors, category_ids: task?.category_ids || [],
                            ...taskDetails
                        });
                        formik.setFieldValue("exhibitors", task?.category_ids?.length > 0 ? [] : task?.exhibitors);
                        formik.setFieldValue("category_ids", task?.category_ids || []);
                        setEditCategoryIds(formik?.values?.category_ids || []);
                    } else {
                        throw new Error('No asset data received')
                    }
                } catch (error) {
                    const errorMessage = error?.response?.data?.message ||
                        'Error loading asset data'

                    errorToaster(errorMessage)

                    // Redirect back to asset library if asset not found
                    if (error?.response?.status === 404) {
                        history.push(`/e/${props?.eventInfo?.event_id}/exhibitor-portal/asset-library`)
                    }
                } finally {
                    setLoading(false)
                }
            }
        }

        fetchAssetData()
    }, [isEdit, assetId, props?.eventInfo?.event_id, history])

    const handleShareTypeToggle = (isExhibitor) => {
        setIsExhibitorToggle(isExhibitor)
       
    }
    return (
        <div>
         {loading ? <LoadingSpinner /> :
            <KonfhubContainer>
                <h4 className="px-sm-4 px-2 pt-2 asset-library-edit-add-title mb-0 mb-sm-2">
                    <img src={backbtn} alt="Back" className="richtext-cursor-pointer mr-2" onClick={() => {
                        history.push(`/e/${props?.eventInfo?.event_id}/exhibitor-portal/asset-library`);
                    }} />
                    {isEdit ? ASSET_LABELS?.EDIT_ASSET : ASSET_LABELS?.CREATE_ASSET}
                </h4>

                <AddNEditAsset
                    formik={formik}
                    isEdit={isEdit}
                    assetTypes={ASSET_TYPES}
                    eventInfo={props?.eventInfo}
                    loading={loading}
                    isExhibitorToggle={isExhibitorToggle}
                    setIsExhibitorToggle={setIsExhibitorToggle}
                    onShareTypeToggle={handleShareTypeToggle}
                    props={props}
                     setEditCategoryIds={setEditCategoryIds}
                     setLoading={setLoading}
                     assetDetails={assetDetails}
                />

                <style>{`
                    .asset-library-edit-add-title {
                        color: ${dashboardColors[theme].primaryTextColor};
                        font-weight: 600;
                        font-size: 18px;
                    }
                `}</style>
            </KonfhubContainer>
         }
        </div>
    )
}

export default AddNEditAssetInterface
